import {gql} from "@apollo/client/core";
import {ProductImageFragment} from "../cart-product/product-image-fragment";

export const OrderHistoryProductViewFragment = gql`
    fragment OrderHistoryProductViewFragment on OrderHistoryProductView {
        id
        usanaId
        mhpId
        quantity
        price
        totalPrice
        discount
        volume
        totalVolume
        name
        productImages {
            ...ProductImageFragment
        }
        canAddToCart
        sourcePrebuiltPackId
    }
    ${ProductImageFragment}
`;
